export enum MapViewport {
  /** Used on mobile view fixed  */
  FullPage = 'map-view-full-page',
  /** Used on map large */
  PrimarySection = 'map-view-primary-section',
  /** Used for modules */
  ModuleView = 'map-view-module',
}

export enum MapType {
  STATIC = 'map--static',
  MAIN = 'Map--main',
  MAIN_TRAFFIC = 'Map--main-traffic',
  WARNING = 'Map--warning',
}
